exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .cls-1 {\n    fill: #091c28;\n  }\n", ""]);
